import Vue from 'vue'
import App from './App.vue'
import router from './router'

import dotenv from 'dotenv'
dotenv.config()

//Bootstrap-vue
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-icons/font/bootstrap-icons.css';
import { i18n } from '@/plugins/i18n'
import { MonthPicker } from 'vue-month-picker'
import { MonthPickerInput } from 'vue-month-picker'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(MonthPicker)
Vue.use(MonthPickerInput)


Vue.config.productionTip = false
Vue.filter('etiqueta', function (value) {
  if (!value) return ''
  let t = value.text;
  let i;      
  let traduccions =  value.traduccions;  
  if(traduccions){
    for(i = 0; i < traduccions.length; i++) {
      if(traduccions[i].idioma == i18n.locale){
        return traduccions[i].text;
      }
    }
  }
  
  return t
})

new Vue({
  i18n,
  router,
  render: h => h(App),
}).$mount('#app')
